import {
  BasketShoppingSolidIcon,
  BrandsIcon,
  CheckCircleIcon,
  ClockSolidIcon,
  CustomersOverviewEntity,
  DeliveriesTodayInfoEntity,
  DollarHandIcon,
  DollarSignSolidIcon,
  GrubconIcon,
  InfoIcon,
  NumberType,
  OrdersTodayInfoEntity,
  PercentSolidIcon,
  StoreIcon,
  WalletSolidIcon,
  displayCentsInDollars,
  lightTheme,
} from '@vgrubs/components';

export const summary = (data: OrdersTodayInfoEntity | null) => {
  return [
    {
      label: 'Total Sales',
      amount: data?.totalSales || 0,
      color: lightTheme.green,
      Icon: WalletSolidIcon,
      byProvider: data?.totalSalesByProvider.map((provider) => ({
        provider: provider.provider,
        amount: provider.totalSales,
      })),
      currency: NumberType.USD,
    },
    {
      label: 'Total Orders',
      amount: data?.totalOrdersCount || 0,
      color: lightTheme.green,
      Icon: BasketShoppingSolidIcon,
      byProvider: data?.totalOrdersCountByProvider.map((provider) => ({
        provider: provider.provider,
        amount: provider.totalOrdersCount,
      })),
      currency: NumberType.NUMBER,
    },
    {
      label: 'Total Taxes',
      amount: data?.totalTaxes || 0,
      color: lightTheme.orange,
      Icon: PercentSolidIcon,
      byProvider: data?.totalTaxesByProvider.map((provider) => ({
        provider: provider.provider,
        amount: provider.totalTaxes,
      })),
      currency: NumberType.USD,
    },
    {
      label: 'Total Recovered',
      amount: data?.totalRecovered || 0,
      color: lightTheme.darkYellow,
      Icon: GrubconIcon,
      byProvider: data?.totalRecoveredByProvider.map((provider) => ({
        provider: provider.provider,
        amount: provider.totalRecovered,
      })),
      currency: NumberType.USD,
    },
    {
      label: 'Total Cancelled',
      amount: data?.totalCancelled || 0,
      color: lightTheme.primary,
      Icon: InfoIcon,
      byProvider: data?.totalCancelledByProvider.map((provider) => ({
        provider: provider.provider,
        amount: provider.totalCancelled,
      })),
      currency: NumberType.NUMBER,
    },
  ];
};

export const summaryDeliveries = (data: DeliveriesTodayInfoEntity | null) => {
  return [
    {
      label: 'Total Sales',
      amount: data?.totalSales || 0,
      color: lightTheme.darkBlue,
      Icon: WalletSolidIcon,
      byProvider: data?.totalSalesByProvider.map((provider) => ({
        provider: provider.provider,
        amount: provider.totalSales,
      })),
      currency: NumberType.USD,
    },
    {
      label: 'Active Locations',
      amount: data?.activeStoresCount || 0,
      color: lightTheme.blue,
      Icon: BrandsIcon,
      byProvider: undefined,
      currency: NumberType.NUMBER,
    },

    {
      label: 'Total Completed',
      amount: data?.totalCompletedCount || 0,
      color: lightTheme.green,
      Icon: CheckCircleIcon,
      byProvider: data?.totalCompletedCountByProvider.map((provider) => ({
        provider: provider.provider,
        amount: provider.totalDeliveriesCount,
      })),
      currency: NumberType.NUMBER,
    },
    {
      label: 'Total Failed',
      amount: data?.totalCancelledCount || 0,
      color: lightTheme.primary,
      Icon: InfoIcon,
      byProvider: data?.totalCancelledCountByProvider.map((provider) => ({
        provider: provider.provider,
        amount: provider.totalDeliveriesCount,
      })),
      currency: NumberType.NUMBER,
    },
    {
      label: 'Average Delivery Time',
      amount: data?.averageDeliveryTime || 0,
      color: lightTheme.orange,
      Icon: ClockSolidIcon,
      byProvider: data?.averageDeliveryTimeByProvider.map((provider) => ({
        provider: provider.provider,
        amount: provider.averageDeliveryTime,
      })),
      currency: NumberType.MINUTES,
    },
    {
      label: 'Average Assignment Time',
      amount: data?.averageAssignmentTime || 0,
      color: lightTheme.orange,
      Icon: ClockSolidIcon,
      byProvider: data?.averageAssignmentTimeByProvider.map((provider) => ({
        provider: provider.provider,
        amount: provider.averageAssignmentTime,
      })),
      currency: NumberType.MINUTES,
    },
    {
      label: 'Total DSP Fee',
      amount: data?.totalTaxes || 0,
      color: lightTheme.darkBlue,
      Icon: PercentSolidIcon,
      byProvider: data?.totalTaxesByProvider.map((provider) => ({
        provider: provider.provider,
        amount: provider.totalDSPFees,
      })),
      currency: NumberType.USD,
    },
    {
      label: 'Total Tip',
      amount: data?.totalTips || 0,
      color: lightTheme.darkBlue,
      Icon: DollarHandIcon,
      byProvider: data?.totalTipsByProvider.map((provider) => ({
        provider: provider.provider,
        amount: provider.totalTips,
      })),
      currency: NumberType.USD,
    },
    {
      label: 'Average Tip',
      amount: data?.averageTips || 0,
      color: lightTheme.darkBlue,
      Icon: DollarHandIcon,
      byProvider: data?.averageTipsByProvider.map((provider) => ({
        provider: provider.provider,
        amount: provider.averageTips,
      })),
      currency: NumberType.USD,
    },
  ];
};

export const dataChart = [
  {
    name: 'May 01',
    totalSales: 29520,
    totalSalesLastMonth: 27500,
    totalOrders: 85,
    totalOrdersLastMonth: 77,
    totalTaxes: 5100,
    totalTaxesLastMonth: 4800,
    totalRecovered: 71200,
    totalRecoveredLastMonth: 66700,
    totalCancelled: 46,
    totalCancelledLastMonth: 46,
  },
  {
    name: 'May 02',
    totalSales: 30870,
    totalSalesLastMonth: 28600,
    totalOrders: 91,
    totalOrdersLastMonth: 82,
    totalTaxes: 5230,
    totalTaxesLastMonth: 4980,
    totalRecovered: 73500,
    totalRecoveredLastMonth: 68900,
    totalCancelled: 52,
    totalCancelledLastMonth: 46,
  },
  {
    name: 'May 03',
    totalSales: 32240,
    totalSalesLastMonth: 29600,
    totalOrders: 94,
    totalOrdersLastMonth: 87,
    totalTaxes: 5470,
    totalTaxesLastMonth: 5090,
    totalRecovered: 74800,
    totalRecoveredLastMonth: 68800,
    totalCancelled: 58,
    totalCancelledLastMonth: 46,
  },
  {
    name: 'May 04',
    totalSales: 28900,
    totalSalesLastMonth: 26600,
    totalOrders: 83,
    totalOrdersLastMonth: 75,
    totalTaxes: 4950,
    totalTaxesLastMonth: 4680,
    totalRecovered: 69300,
    totalRecoveredLastMonth: 65400,
    totalCancelled: 49,
    totalCancelledLastMonth: 46,
  },
  {
    name: 'May 05',
    totalSales: 31050,
    totalSalesLastMonth: 28900,
    totalOrders: 89,
    totalOrdersLastMonth: 81,
    totalTaxes: 5300,
    totalTaxesLastMonth: 4930,
    totalRecovered: 72800,
    totalRecoveredLastMonth: 68200,
    totalCancelled: 50,
    totalCancelledLastMonth: 46,
  },
  {
    name: 'May 06',
    totalSales: 30320,
    totalSalesLastMonth: 28300,
    totalOrders: 88,
    totalOrdersLastMonth: 80,
    totalTaxes: 5180,
    totalTaxesLastMonth: 4850,
    totalRecovered: 71500,
    totalRecoveredLastMonth: 67300,
    totalCancelled: 43,
    totalCancelledLastMonth: 46,
  },
  {
    name: 'May 07',
    totalSales: 29910,
    totalSalesLastMonth: 27100,
    totalOrders: 87,
    totalOrdersLastMonth: 79,
    totalTaxes: 5120,
    totalTaxesLastMonth: 4710,
    totalRecovered: 70100,
    totalRecoveredLastMonth: 66300,
    totalCancelled: 44,
    totalCancelledLastMonth: 46,
  },
  {
    name: 'May 08',
    totalSales: 31200,
    totalSalesLastMonth: 28700,
    totalOrders: 92,
    totalOrdersLastMonth: 83,
    totalTaxes: 5400,
    totalTaxesLastMonth: 5040,
    totalRecovered: 74000,
    totalRecoveredLastMonth: 69900,
    totalCancelled: 57,
    totalCancelledLastMonth: 46,
  },
  {
    name: 'May 09',
    totalSales: 29050,
    totalSalesLastMonth: 26800,
    totalOrders: 86,
    totalOrdersLastMonth: 79,
    totalTaxes: 5000,
    totalTaxesLastMonth: 4750,
    totalRecovered: 70800,
    totalRecoveredLastMonth: 66500,
    totalCancelled: 45,
    totalCancelledLastMonth: 46,
  },
  {
    name: 'May 10',
    totalSales: 30580,
    totalSalesLastMonth: 28000,
    totalOrders: 90,
    totalOrdersLastMonth: 83,
    totalTaxes: 5270,
    totalTaxesLastMonth: 4890,
    totalRecovered: 73200,
    totalRecoveredLastMonth: 68700,
    totalCancelled: 53,
    totalCancelledLastMonth: 46,
  },
];

export const dataCustomers = (data: CustomersOverviewEntity) => [
  {
    name: 'New Customers',
    value: data.newCustomers || 0,
    color: lightTheme.blue,
  },
  {
    name: 'Returning Customers',
    value: data.returningCustomers || 0,
    color: lightTheme.green,
  },
];

export const dataSuccessRate = (data: any) => [
  {
    name: 'Delivered Success',
    value: data.successfulDeliveries || 0,
    color: lightTheme.green,
  },
  {
    name: 'Delivered Failed',
    value: data.failedDeliveries || 0,
    color: lightTheme.primary,
  },
];

export const dataTrackingSuccessRate = (data: any) => [
  {
    name: 'Success SMS',
    value: data.successfulMessages || 0,
    color: lightTheme.green,
  },
  {
    name: 'Failed SMS',
    value: data.failedMessages || 0,
    color: lightTheme.primary,
  },
];

export const revenueDummy = [
  {
    label: 'Total Revenue',
    onClick: () => undefined,
    amount: displayCentsInDollars(28500),
    color: lightTheme.yellow,
    Icon: DollarSignSolidIcon,
  },
  {
    label: 'Total vGrubs Revenue',
    onClick: () => undefined,
    amount: displayCentsInDollars(28500),
    color: lightTheme.yellow,
    Icon: DollarSignSolidIcon,
  },
  {
    label: 'Total vDrive Revenue',
    onClick: () => undefined,
    amount: displayCentsInDollars(28500),
    color: lightTheme.yellow,
    Icon: DollarSignSolidIcon,
  },
  {
    label: 'Total Collected Fee Revenue',
    onClick: () => undefined,
    amount: displayCentsInDollars(28500),
    color: lightTheme.yellow,
    Icon: DollarSignSolidIcon,
  },
];

export const vPayDummy = [
  {
    label: 'Total Blue Card Balance',
    amount: displayCentsInDollars(28500),
    list: [
      {
        name: 'Bessie Cooper',
        date: 'March 1, 2024',
        amount: displayCentsInDollars(2800),
      },
    ],
  },
  {
    label: 'Total Blue Card Withdrawals',
    amount: displayCentsInDollars(28500),
  },
  {
    label: 'Total Manually Completed Payments',
    amount: displayCentsInDollars(28500),
  },
  {
    label: 'Total Manually Initiated Payments',
    amount: displayCentsInDollars(28500),
  },
  {
    label: 'Number of Clients Maintaining the Balance Over $100',
    amount: displayCentsInDollars(28500),
  },
];

export const dataDeliverySuccessRate = [
  { name: 'Delivered Success', value: 785, color: lightTheme.green },
  { name: 'Delivered Failed', value: 355, color: lightTheme.primary },
  // { name: 'Total Customers', value: 1233, color: lightTheme.primary },
];
